import { Injectable } from '@angular/core';
import { Product } from '@spartacus/core';

import { BaseStoreService } from './base-store.service';

@Injectable({
  providedIn: 'root'
})
export class StockService {
  constructor(private readonly baseStoreService: BaseStoreService) {};

  checkStock(price: number, stock: number): boolean {
    const lowStockConfig = this.baseStoreService?.baseStore?.lowStockConfig;
    if (!Array.isArray(lowStockConfig)) return false;

    for (const lowStockRule of lowStockConfig) {
      if (price >= lowStockRule.minPrice && price < lowStockRule.maxPrice) {
        return stock <= lowStockRule.threshold;
      }
    }
    return false;
  }

  isBundleLowStock(products: Product[]): boolean {
    for (const product of products) {
      if (this.checkStock(product?.price?.value, product?.stock?.stockLevel)) {
        return true;
      }
    }
    return false;
  }
}
